import React, { Component } from "react";

export class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <hr></hr>
        <div>
          Instituto Politécnico de Bragança | <strong>ipb.pt</strong>
        </div>
        <div>
          <i
            className="fab fa-facebook-square"
            onClick={() =>
              window.open("http://www.facebook.com/ipbraganca", "_blank")
            }
          ></i>{" "}
          <i
            className="fab fa-instagram"
            onClick={() =>
              window.open(
                "https://www.instagram.com/institutopolitecnicobraganca",
                "_blank"
              )
            }
          ></i>
        </div>
      </footer>
    );
  }
}

export default Footer;
